import { useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";

export default function useModal() {
    const [showModal, setShowModal] = useState();
    const [modalType, setModalType] = useState();
    const [modalTitle, setModalTitle] = useState();
    const [modalMessage, setModalMessage] = useState();
    const resolver = useRef();

    function showAlert(title, message) {
        setModalType("alert");
        setModalTitle(title);
        setModalMessage(message);
        setShowModal(true);
        return new Promise(res => resolver.current = res);
    }

    function showConfirm(title, message) {
        setModalType("confirm");
        setModalTitle(title);
        setModalMessage(message);
        setShowModal(true);
        return new Promise(res => resolver.current = res);
    }

    const ModalDialog = (
        <Modal show={showModal} onHide={() => (setShowModal(false), resolver.current(false))}>
            <Modal.Header closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {typeof modalMessage === "string" ? <p>{modalMessage}</p> : modalMessage}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => (setShowModal(false), resolver.current(true))}>OK</Button>
                {modalType === "confirm" && <Button variant="secondary" onClick={() => (setShowModal(false), resolver.current(false))}>Cancel</Button>}
            </Modal.Footer>
        </Modal>
    );

    return { ModalDialog, showAlert, showConfirm };
}